import { render, staticRenderFns } from "./AuthorizationBlock.vue?vue&type=template&id=94f2ebbe&scoped=true&"
import script from "./AuthorizationBlock.vue?vue&type=script&lang=ts&"
export * from "./AuthorizationBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f2ebbe",
  null
  
)

export default component.exports